import type { RouteObject } from 'react-router';

import { PlansPage } from './Plans';

/**
 * `/plans`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It sits inside the console layout route, which already runs the guard chain —
 * `sessionInMemory? → silentRefreshOnceOn401 → me() → roleGate` — so this route
 * adds no loader of its own. The guard decides **navigation** only: `backend-finance`
 * re-checks the caller's role on every read and every write, and the origin a
 * call arrives from is never an authorization input.
 *
 * The route map admits an `operator` here and requires `admin` on the writes;
 * the console does not pre-compute that outcome. An `operator` who reaches a
 * write meets the service's own `403` and the surface renders it.
 */
export const plansRoute: RouteObject = {
  path: 'plans',
  element: <PlansPage />,
};
